<template>
    <h2 class="text-left text-2xl">
        {{ $t('timesheet.Arbeitserfassung') }}
    </h2>
    <div class="my-[3%] text-left">
        <router-link to="/createjob" class="my-5 text-left">
            <button
                class="text-center font-medium text-xl align-middle leading-[3rem] cursor-pointer rounded shadow bg-[#FFF] text-black lg:w-[40%] w-full border-[1px] border-black"
            >
                {{ $t('timesheet.addTask') }}
            </button>
        </router-link>
    </div>
    <div class="border-[1px] mb-[3%] border-gray-400">
        <div>
            <div class="lg:w-1/3 w-full inline-grid p-[20px] pb-0">
                <div class="flex justify-between flex-wrap w-full my-4">
                    <div class="relative inline-block w-full text-gray-700">
                        <select
                            class="pl-[14px] pt-3 shadow w-full h-[55px] pr-6 text-base placeholder-gray-600 border rounded-lg appearance-none focus:shadow-outline"
                        >
                            <option value="">Bitte auswählen</option>
                            <!-- make translation -->
                            <option v-for="n in 10">{{ $t('timesheet.Aufgabe') }} {{ n }}</option>
                        </select>
                        <label class="absolute left-4 text-gray-400 text-sm top-1">
                            {{ $t('timesheet.Aufgabe') }}</label
                        >
                        <div
                            class="absolute inset-y-0 lg:right-[2%] right-0 flex items-center px-2 pointer-events-none"
                        >
                            <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20">
                                <path
                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4
                                    4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                    clip-rule="evenodd"
                                    fill-rule="evenodd"
                                ></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lg:w-1/3 w-full inline-grid p-[20px]">
                <div class="flex justify-between flex-wrap w-full mt-2">
                    <div class="relative w-full">
                        <input
                            :id="$t('timesheet.Beschreibung')"
                            class="w-full rounded-lg shadow pl-4 pt-3 peer placeholder-transparent h-[55px] border-[1px] border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:border-b-[#db0720]"
                            :placeholder="$t('timesheet.Beschreibung')"
                        />
                        <label
                            :for="$t('timesheet.Beschreibung')"
                            class="absolute left-4 text-gray-400 text-sm top-1 peer-placeholder-shown:text-lg peer-placeholder-shown:text-gray-600 peer-placeholder-shown:top-4 transition-all peer-focus:top-1 peer-focus:text-gray-400 peer-focus:text-sm hover:cursor-text"
                            >{{ $t('timesheet.Beschreibung') }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="lg:w-1/4 w-full inline-flex p-[20px] justify-evenly max-lg:mb-5">
                <div class="flex justify-between flex-wrap mt-2">
                    <div class="relative w-full">
                        <input
                            id="von"
                            class="w-full rounded-lg shadow pl-4 pt-3 peer placeholder-transparent h-[55px] border-[1px] border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:border-b-[#db0720]"
                            placeholder="von"
                            type="time"
                        />
                        <label
                            for="von"
                            class="absolute left-4 text-gray-500 text-sm top-1 peer-placeholder-shown:text-lg peer-placeholder-shown:text-gray-600 peer-placeholder-shown:top-4 transition-all peer-focus:top-1 peer-focus:text-gray-500 peer-focus:text-sm hover:cursor-text"
                            >von
                            <!-- translate -->
                        </label>
                    </div>
                </div>
                <div class="flex justify-between flex-wrap mt-2">
                    <div class="relative w-full">
                        <input
                            id="bis"
                            class="w-full rounded-lg shadow pl-4 pt-3 peer placeholder-transparent h-[55px] border-[1px] border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:border-b-[#db0720]"
                            placeholder="bis"
                            type="time"
                        />
                        <label
                            for="bis"
                            class="absolute left-4 text-gray-500 text-sm top-1 peer-placeholder-shown:text-lg peer-placeholder-shown:text-gray-600 peer-placeholder-shown:top-4 transition-all peer-focus:top-1 peer-focus:text-gray-500 peer-focus:text-sm hover:cursor-text"
                            >bis
                            <!-- translate -->
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div
                class="lg:w-[10%] w-1/2 inline-flex p-[20px] justify-evenly max-lg:mb-5 align-super"
            >
                <form class="pt-[4%]">
                    <label
                        class="block relative pl-[35px] mb-[12px] cursor-pointer text-xl select-none"
                        >{{ $t('timesheet.Spesen') }}
                        <input
                            type="checkbox"
                            name="organisation"
                            class="absolute opacity-0 cursor-pointer h-0 w-0 peer"
                        />
                        <span
                            class="absolute top-0 left-0 h-[25px] w-[25px] bg-[#ccc] rounded-[50px] peer-checked:bg-[#0faedd]"
                        ></span>
                    </label>
                </form>
            </div>
            <div class="lg:w-1/4 w-1/2 inline-grid p-[20px]">
                <div class="flex justify-between flex-wrap w-full mt-2">
                    <div class="relative w-full mb-2">
                        <input
                            :id="$t('timesheet.PauschalDesktop')"
                            class="w-full rounded-lg shadow pl-4 pt-3 peer placeholder-transparent h-[50px] border-[1px] border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:border-b-[#db0720]"
                            :placeholder="
                                screenWidth >= 1000
                                    ? $t('timesheet.PauschalDesktop')
                                    : $t('timesheet.PauschalMobile')
                            "
                        />
                        <label
                            :for="$t('timesheet.PauschalDesktop')"
                            class="absolute left-4 text-gray-400 text-sm top-1 peer-placeholder-shown:text-lg peer-placeholder-shown:text-gray-600 peer-placeholder-shown:top-3 transition-all peer-focus:top-1 peer-focus:text-gray-400 peer-focus:text-sm hover:cursor-text"
                            >{{
                                screenWidth >= 1000
                                    ? $t('timesheet.PauschalDesktop')
                                    : $t('timesheet.PauschalMobile')
                            }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="lg:w-1/5 w-full inline-grid p-[20px] align-super">
                <button
                    class="h-[50px] text-lg text-center font-medium align-middle leading-8 cursor-pointer rounded shadow bg-[#FFF] text-black border-[1px] border-black hover:bg-[#F7F7F7] w-full"
                >
                    {{ $t('timesheet.Zurücksetzen') }}
                </button>
            </div>
            <div class="lg:w-1/3 w-full text-xl inline-grid p-[20px] align-super">
                <button
                    class="h-[50px] lg:my-2 text-center font-medium align-middle leading-8 cursor-pointer rounded shadow bg-[#db0720] text-white hover:bg-[#ce0720] w-full"
                >
                    {{ $t('timesheet.Erfassen') }}
                </button>
            </div>
        </div>
    </div>
    <hr />

    <!-- Timesheet -->

    <h2 class="my-[3%] text-left text-2xl">{{ $t('timesheet.Timesheet') }}</h2>
    <div class="overflow-x-auto shadow">
        <table class="w-full border-[1px] text-left max-lg:text-sm text-lg">
            <thead class="text-white">
                <tr class="border-b-[1px] border-black bg-[#db0720] py-2">
                    <th class="w-[8.5%] font-medium p-3">
                        {{ $t('timesheet.table1.1') }}
                    </th>
                    <th class="w-[8.5%] font-medium p-3">
                        {{ $t('timesheet.table1.2') }}
                    </th>
                    <th class="w-[8.5%] font-medium p-3">
                        {{ $t('timesheet.table1.3') }}
                    </th>
                    <th class="w-[8.5%] font-medium p-3">
                        {{ $t('timesheet.table1.4') }}
                    </th>
                    <th class="w-1/4 font-medium p-3">
                        {{ $t('timesheet.table1.5') }}
                    </th>
                    <th class="w-1/4 font-medium p-3">
                        {{ $t('timesheet.table1.6') }}
                    </th>
                    <th class="w-[16%] font-medium p-3" colspan="2">
                        {{ $t('timesheet.table1.7') }}
                    </th>
                </tr>
            </thead>
            <tbody v-if="timesheetInstances.length != 0">
                <tr v-for="instance in timesheetInstances" class="border-b-2">
                    <td class="w-[8.5%] font-normal p-3">
                        <strong>{{ instance.jobId }}</strong>
                    </td>
                    <td class="w-[8.5%] font-normal p-3">
                        {{ instance.start }}
                    </td>
                    <td class="w-[8.5%] font-normal p-3">{{ instance.end }}</td>
                    <td class="w-[8.5%] font-normal p-3">
                        {{ instance.length }}
                    </td>
                    <td class="w-1/4 font-normal p-3">{{ instance.task }}</td>
                    <td class="w-1/4 font-normal p-3">
                        {{ instance.description }}
                    </td>
                    <td class="w-[16%] font-normal p-3">
                        <!-- <router-link to='/contacts/A/3'> -->
                        <button>
                            <img
                                src="@/assets/images/Arrow_right.png"
                                alt="Open"
                                class="lg:w-[35px] w-[20px]"
                            />
                        </button>
                        <!-- </router-link> -->
                        <!-- <router-link to='/contacts/L/3'> -->
                        <button class="lg:ml-[25%] ml-[20px]">
                            <img
                                src="@/assets/images/Trash.png"
                                alt="Del"
                                class="lg:w-[35px] w-[20px]"
                            />
                        </button>
                        <!-- </router-link> -->
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td class="col-span-8">{{ $t('timesheet.Nothing') }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="container text-center my-[2%]">
        <div class="flex flex-wrap">
            <div class="w-1/2">
                <h3 class="my-4 whitespace-nowrap overflow-hidden">
                    <span v-if="screenWidth >= 1000">{{ $t('timesheet.TotalWork') }}: </span>
                    <strong>{{ whiteAreaValues.workTime }}</strong>
                </h3>
            </div>
            <div class="w-1/2">
                <h3 class="my-4 whitespace-nowrap overflow-hidden">
                    <strong>
                        {{ whiteAreaValues.workLoad }}
                        %
                        <span v-if="screenWidth >= 1000">{{ $t('timesheet.Pensum') }}</span>
                    </strong>
                </h3>
            </div>
        </div>
    </div>
    <hr />

    <!-- Tasks -->

    <h2 class="my-[3%] text-left text-2xl">{{ $t('timesheet.Pendent') }}</h2>
    <div class="overflow-x-auto shadow">
        <table class="w-full border-[1px] text-left max-lg:text-sm text-lg">
            <thead class="text-white">
                <tr class="border-b-[1px] border-black bg-[#db0720] py-2">
                    <th class="w-[10%] font-medium p-3">
                        {{ $t('timesheet.table2.1') }}
                    </th>
                    <th class="w-[30%] font-medium p-3">
                        {{ $t('timesheet.table2.2') }}
                    </th>
                    <th class="w-[20%] font-medium p-3">
                        {{ $t('timesheet.table2.3') }}
                    </th>
                    <th class="w-[20%] font-medium p-3">
                        {{ $t('timesheet.table2.4') }}
                    </th>
                    <th class="w-[20%] font-medium p-3" colspan="2">
                        {{ $t('timesheet.table2.5') }}
                    </th>
                </tr>
            </thead>
            <tbody v-if="tasktableInstances.length != 0">
                <tr v-for="instance in tasktableInstances" class="border-b-2">
                    <td class="w-[10%] font-normal p-3">
                        <strong>{{ instance.jobId }}</strong>
                    </td>
                    <td class="w-[30%] font-normal p-3">{{ instance.task }}</td>
                    <td class="w-[20%] font-normal p-3">
                        {{ instance.status }}
                    </td>
                    <td class="w-[20%] font-normal p-3">
                        {{ instance.taskedDate }}
                    </td>
                    <td class="w-[20%] font-normal p-3">
                        <!-- <router-link to='/contacts/A/3'> -->
                        <button>
                            <img
                                src="@/assets/images/Arrow_right.png"
                                alt="Open"
                                class="lg:w-[35px] w-[20px]"
                            />
                        </button>
                        <!-- </router-link> -->
                        <!-- <router-link to='/contacts/L/3'> -->
                        <button class="lg:ml-[25%] ml-[20px]">
                            <img
                                src="@/assets/images/Trash.png"
                                alt="Del"
                                class="lg:w-[35px] w-[20px]"
                            />
                        </button>
                        <!-- </router-link> -->
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td class="col-span-6">{{ $t('timesheet.Nothing') }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- END WHITE ZONE -->

    <canvas class="h-[100px]"></canvas>
</template>

<script lang="js">
    import { defineComponent } from 'vue'
    import sourceData from '@/components/MockJSONFiles (temp)/MockJSONTimesheetFile.json' // MOCK JSON file
    import { useI18n } from 'vue-i18n'

    export default defineComponent({
        data() {
            return {
                screenWidth: window.innerWidth,
                whiteAreaValues: {
                    workTime: '--:--',
                    workLoad: 0,
                },
                timesheetInstances: sourceData.timesheetInstances, // {jobId; start; end; length; task; description}
                tasktableInstances: sourceData.tasks, // {jobId; task; status; taskedDate}
            }
        },
        mounted() {
            window.addEventListener('resize', this.getDimensions)
        },

        methods: {
            getDimensions() {
                this.screenWidth = document.documentElement.clientWidth
            },
        },
    })
</script>
